import purify from "dompurify"

export default function displayFlash(text, type) {
  let $flash = document.querySelector(".flash-msg")

  if (!$flash) {
    $flash = document.createElement("div")
    document.body.appendChild($flash)
  }

  $flash.className = `flash-msg fadein ${type ? type : "alert"}`
  $flash.innerText = purify.sanitize(text)

  setTimeout(() => {
    document.querySelectorAll(".flash-msg:not(.sticky)").forEach(el => {
      el.classList.remove("fadein")
      el.classList.add("fadeout")
      setTimeout(() => {
        el.style.display = "none"
      }, 500)
    })
  }, 4000)
}
